export const purchaseFr = {
  "Fournisseur": "Fournisseur",
  "Prix.U": "Prix.U",
  "Prix.V": "Prix.V",
  "Facture": "Facture",

  "Donner le prix d'achat": "Donner le prix d'achat",
  "Donner le prix de vente": "Donner le prix de vente",
  "Donner la quantité": "Donner la quantité",
  "Prix D'achat": "Prix D'achat",
  "Prix de vente": "Prix de vente",
  "Quantité": "Quantité",
  "Ajouter": "Ajouter",
  "Modifier": "Modifier",
  "Supprimer": "Supprimer",
  "Fermer": "Fermer",

  "Chercher un bon d'achat": "Chercher une facture d'achat",

  
}